import React from 'react';
import styled from '@emotion/styled';
import SPACING, { SpacingKeys } from '../size';

export type LogoStyle = 'full' | 'small';
export type LogoColor = 'light' | 'dark' | 'orange';

export type LogoProps = {
  logo: LogoStyle;
  color: LogoColor;
  size: SpacingKeys | string;
};

const LogoWrapper = styled.img<{ width }>(({ width }) => ({
  width,
  height: 'auto',
}));

/**
 * A futuro logo
 *
 * @argument logo string - logo of the logo, either "full" or "small"
 * @argument color string - color mode of the logo, either "light" or "dark" or "orange"
 * @argument size string - either a size as defined in the spacing system, or a
 *     raw css size value.
 *
 * Based off the logos in the figma file:
 *
 * https://www.figma.com/file/zYke5qihweC8yQSpXpcRO2/%F0%9F%93%9000-OM-CORE-Library?node-id=29%3A0
 *
 * File naming of an svg logo should be: logo-ordermentum-{logo}-{color}.svg
 *
 * @example
 *
 * <Logo logo="full" color="light" size="1rem" />
 * <Logo logo="full" color="dark" size="70%" />
 * <Logo logo="small" color="light" size={S.XL} />
 * <Logo logo="small" color="dark" size="20px" />
 */
const Logo = (props: LogoProps) => {
  const { logo, color, size } = props;
  const width = SPACING[size] || size;

  return (
    <LogoWrapper
      src={`${process.env.IMAGE_URL}/logo-ordermentum-${logo}-${color}.svg`}
      alt="Ordermentum logo"
      width={width}
    />
  );
};

export default Logo;
